import { useEffect, useState } from 'react';

const useDebouncedValue = <T>(value: T, ms = 300) => {
  const [v, setV] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);

  return v;
};

export default useDebouncedValue;
